module.exports = __webpack_public_path__ + "img/shopping-cart-black.f082c037.svg";